import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BackendService } from '../../services/backend-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CreateCheckoutPayload, RentalOption, VehicleTypeDTO, CarDetails, BoatDetails } from '../../types/api.types';

type VehicleType = 'car' | 'boat';

// export interface CheckoutOption {
//   id: string;
//   duration: string;
//   rate: number;
//   flat_fee: number;
// }

// export interface CheckoutSubmitEvent {
//   selectedOption: CheckoutOption;
//   licensePlate: string;
//   color: string;
//   vehicleMake: string | null;
//   description: string | null;
//   email: string;
//   phoneNumber: string;
//   customerName: string;
// }


@Component({
  selector: 'app-checkout',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './checkout.html',
  styleUrl: './checkout.scss',
})
export class Checkout {
  devMode: boolean = false;
  submitData: any = "empty";
  dataSubmitted: any = false;

  @Input() headerImage: string = '';
  @Input() sourceLandingPageId!: number;
  @Input() title!: string | null;
  @Input() options: RentalOption[] = [];
  @Input() vehicleTypes: VehicleTypeDTO[] = [];
  @Output() checkoutError = new EventEmitter<string>();
  
  constructor(private backendService: BackendService) {}

  selectedOption: RentalOption | null = null;

  // Contact fields
  customerName = '';
  email = '';
  phoneNumber = '';

  // Vehicle fields
  color = '';
  vehicleDescription = '';
  selectedVehicleType: string = 'car';
  
  // *Car specific
  vehicleMake = '';
  licensePlate = '';
  
  // *Boat specific
  boatName = '';
  hullId = '';
  boatLength: number = -1;
  slipNumber = '';

  ngOnInit() {
    if (this.options.length > 0) {
      this.selectedOption = this.options[0];
    }
    if (this.vehicleTypes.length > 0) {
      this.selectedVehicleType = this.vehicleTypes[0]?.vehicleType ?? 'car';
    }
  }

  selectOption(option: RentalOption) {
    this.selectedOption = option;
  }

  getTotal(): number {
    if (!this.selectedOption) return 0;
    return this.selectedOption.flat_fee ?? 0;
  }

  isFormValid(): boolean {
    if (!this.selectedOption || !this.customerName) {
      return false;
    }

    if (this.selectedVehicleType === 'boat') {
      return !!(
        this.boatName &&
        this.hullId &&
        this.boatLength &&
        this.slipNumber
      );
    }

    // default: car
    return !!(
      this.licensePlate &&
      this.color &&
      (this.vehicleMake || this.vehicleDescription)
    );
  }

  isVehicleType(value: string): value is VehicleType {
    return (['car', 'boat'] as string[]).includes(value);
  };

async onSubmit() {
  if (!this.isFormValid() || !this.selectedOption) return;
  
  const payload: CreateCheckoutPayload = {
    sourceLandingPageId: String(this.sourceLandingPageId),
    customerName: this.customerName,
    optionId: String(this.selectedOption.id),
    vehicleType: this.isVehicleType(this.selectedVehicleType) ? this.selectedVehicleType : 'car',
    vehicleDetails: this.buildVehicleDetails(),
    vehicleDescription: this.vehicleDescription
  };

  this.submitData = payload;

  const { sessionUrl } = await this.backendService.createCheckoutSession(payload);

    window.location.href = sessionUrl;

    this.dataSubmitted = sessionUrl;
  }

  private buildVehicleDetails(): CarDetails | BoatDetails {
    switch (this.selectedVehicleType) {
      case 'boat':
        return {
          name: this.boatName,
          hullId: this.hullId,
          length: String(this.boatLength),
          slipNumber: this.slipNumber,
        } as BoatDetails;
      default:
        return {
          licensePlate: this.licensePlate,
          vehicleMake: this.vehicleMake,
          color: this.color,
        } as CarDetails;
    }
  }
}